
import { Card, Row, Col } from "react-bootstrap";

const BannerSection = () => {
  return (
    <section className="py-3">
      <div className="container">
        <div className="row my-5">
          <Row className="g-4">
            {/* Row 1 */}
            <Col xs={12} md={6}>
              <Card className="h-100 img-radius">
                <Card.Body>
                  <Card.Title className='text-3xl font-bold'>Brand Strategy That Aligns & Amplifies</Card.Title>
                  <Card.Text>We turn business objectives into brand architecture. Whether you’re building from scratch or restructuring a complex portfolio, our strategic frameworks ensure clarity, coherence, and longterm growth.
                  </Card.Text>
                  <div className="d-flex flex-column mt-2">
                    <div className="custom-flex-box">Brand Purpose & Positioning</div>
                    <div className="custom-flex-box">Develop Breakthrough Brand Positioning</div>
                    <div className="custom-flex-box">Distill and Deliver Brand Vis ID & Brand Standards</div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} md={6}>
              <Card className="h-100 img-radius">
                <Card.Body>
                  <Card.Title className='text-3xl font-bold'>Pharmaceuticals</Card.Title>
                  <Card.Text>We specialize in naming that’s scientifically sound, globally compliant, and strategically bulletproof. From regulatory screening to trademark defense, our pharma expertise ensures your brand is approved faster, resonates deeper, and stands strong in a competitive, high-stakes marketplace.
                  </Card.Text>
                  <div className="d-flex flex-column mt-2">
                    <div className="custom-flex-box">Fast-Track Approval, Zero Risk</div>
                    <div className="custom-flex-box">Names That Command the Market</div>
                    <div className="custom-flex-box">Global IP Defense, Built In</div>
                  </div>
                </Card.Body>
              </Card>
            </Col>


            {/* Row 2 */}
            <Col xs={12} md={6}>
              <Card className="h-100 img-radius">
                <Card.Body>
                  <Card.Title className='text-3xl font-bold'>Brand Experience That Moves People</Card.Title>
                  <Card.Text>A strong brand isn’t just seen—it’s felt. We design immersive brand experiences that resonate emotionally, drive engagement, and build loyalty.
                  </Card.Text>
                  <div className="d-flex flex-column mt-2">
                    <div className="custom-flex-box">Customer Touchpoint Mapping</div>
                    <div className="custom-flex-box">Brand Architecture & Portfolio Strategy</div>
                    <div className="custom-flex-box">Market-Driven Brand Planning</div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} md={6}>
              <Card className="h-100 img-radius">
                <Card.Body>
                  <Card.Title className='text-3xl font-bold'>Design That Distinguishes</Card.Title>
                  <Card.Text>We bring brands to life with visual and verbal systems that diPerentiate and endure. Every expression—graphic, sonic, or tactile—is crafted to spark recognition and trust.
                  </Card.Text>
                  <div className="d-flex flex-column mt-2">
                    <div className="custom-flex-box">Visual & Verbal Identity Systems</div>
                    <div className="custom-flex-box">Sonic, Haptic & Sensory Branding</div>
                    <div className="custom-flex-box">Packaging Design That Commands Attention</div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Row 3 */}
            <Col xs={12} md={6}>
              <Card className="h-100 img-radius">
                <Card.Body>
                  <Card.Title className='text-3xl font-bold'>Brand Valuation That Proves ROI</Card.Title>
                  <Card.Text>Your brand is one of your most valuable assets. We quantify its impact on customer decisions, loyalty, and financial performance—so you can invest with confidence.
                  </Card.Text>
                  <div className="d-flex flex-column mt-2">
                    <div className="custom-flex-box">Brand Equity & Financial Impact Analysis</div>
                    <div className="custom-flex-box">Market-based brand valuation modeling</div>
                    <div className="custom-flex-box">Benchmarking for M&A and investment decisions</div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} md={6}>
              <Card className="h-100 img-radius">
                <Card.Body>
                  <Card.Title className='text-3xl font-bold'>Brand Management That Sustains Momentum</Card.Title>
                  <Card.Text>From governance systems to executional consistency, we help brands scale with control. Your brand’s promise remains protected across every touchpoint.
                  </Card.Text>
                  <div className="d-flex flex-column mt-2">
                    <div className="custom-flex-box">Brand Governance & Guidelines</div>
                    <div className="custom-flex-box">Brand Portfolio Management</div>
                    <div className="custom-flex-box">Executional Consistency Across Channels</div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

        </div>

      </div>

    </section>
  );
};

export default BannerSection;
